import React from "react";
import { useGraphStore } from '../store.js';

const GraphTableToggle = () => {
    
    const graphTableView = useGraphStore((state) => state.graphTableView);
    const setGraphTableView = useGraphStore((state) => state.setGraphTableView);

    return (
        <div className="chart-table-toggle-wrapper">
            <div className="chart-table-toggle">
                <button 
                    onClick={() => setGraphTableView('chart-view')} 
                    className={`button ${graphTableView === 'chart-view' ? 'is-active' : ''}`}
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.52649 6.47337H12.9012C12.7709 5.03249 12.2028 3.80724 11.1968 2.79762C10.1908 1.78799 8.96736 1.22168 7.52649 1.09868V6.47337ZM6.47724 12.9011V1.09868C4.94499 1.2318 3.66168 1.86187 2.6273 2.98887C1.59293 4.11574 1.07574 5.45274 1.07574 6.99987C1.07574 8.54699 1.59293 9.88399 2.6273 11.0109C3.66168 12.1379 4.94499 12.7679 6.47724 12.9011ZM7.52649 12.9011C8.95724 12.7794 10.1791 12.2109 11.1921 11.1956C12.2051 10.1802 12.7748 8.95587 12.9012 7.52262H7.52649V12.9011Z" fill="#495965"/>
                    </svg>
                    Chart
                </button>
                <button 
                    onClick={() => setGraphTableView('table-view')} 
                    className={`button ${graphTableView === 'table-view' ? 'is-active' : ''}`}
                >
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.29568 13.9734V2.79555H14.4735V13.9734H3.29568ZM4.34493 12.9241H8.36174V10.3503H4.34493V12.9241ZM9.41099 12.9241H13.4242V10.3503H9.41099V12.9241ZM0.526489 11.1112V0.0263672H11.6149V1.07562H1.57574V11.1112H0.526489ZM4.34493 9.30105H8.36174V6.72012H4.34493V9.30105ZM9.41099 9.30105H13.4242V6.72012H9.41099V9.30105ZM4.34493 5.67087H13.4242V3.8448H4.34493V5.67087Z" fill="#495965"/>
                    </svg>
                    Table
                </button>
            </div>
        </div>
    );
};

export default GraphTableToggle;